export const ROUTE_TYPES = {
    Public: "public",
    Protected: "protected",
}